export const OFFER_URL = 'https://cena15.micocinanatural.online/'

export const BRAND_LOGO = 'https://cdn.magicpatterns.com/uploads/7MRZefEv9RSMmXcyVpCpG1/logomcn.png'

export const PRODUCT_COVER =
  'https://cdn.magicpatterns.com/uploads/w7g5vYPn6y3yUV7LJKRkVB/portadacenas.png'
